import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import { IShapeModel } from '../../../../Interface/shape-model.interface';
import { IForegroundSize, ISizeInfo } from '../../../image-size/image-size.interface';
import { FillType, IImageFill } from '../../fill.interface';
import { IImageFillSize } from './image-fill-size.interface';

const MIN = 0;

export default class ImageFillSize implements IImageFillSize {
    private model: IShapeModel;

    public constructor(model: IShapeModel) {
        this.model = model;
    }

    public getBackgroundImageSize(props?: ISizeInfo): IForegroundSize {
        const fillInfo = this.model.getBackgroundFill().getCurrentFill()?.fillInfo as IImageFill;
        const sizeInfo =  { ...this.model.props.style, srcRect: fillInfo.stretch?.fillRect };
        const fixedProps = { ...sizeInfo, ...props };
        const { width, height, srcRect } = fixedProps;
        let pl = MIN; let pr = MIN; let pt = MIN; let pb = MIN;
        let rw = width; let rh = height;
        if (!srcRect) {
            return { pl, pr, pt, pb, rw, rh };
        }
        const { l = 0, r = 0, t = 0, b = 0 } = srcRect;
        pl = width * l;
        pr = width * r;
        rw = width + pl + pr;
        pt = height * t;
        pb = height * b;
        rh = height + pt + pb;
        return { pl, pr, pt, pb, rw, rh };
    }

    public updateBackgroundImageSize(props: Partial<IForegroundSize>, width?: number, height?: number): void {
        if (this.model.getBackgroundFill().getFillType() !== FillType.ImageFill) return;
        const { style } = this.model.props;
        width = width ?? style.width;
        height = height ?? style.height;
        const { pl, pt, rw, rh } = { ...this.getBackgroundImageSize(), ...props };
        const pr = props.pr ?? (rw - width - pl);
        const pb = props.pb ?? (rh - height - pt);
        // 对齐office，当前景宽度为0时，l=0,r=1；高度为0时，t=0,b=1
        const srcRect = {
            l: pl / width,
            r: pr / width,
            t: pt / height,
            b: pb / height,
        };
        const fillInfo = this.model.getBackgroundFill().getCurrentFill()?.fillInfo as IImageFill;
        this.model.getBackgroundFill().updateCurrentFill({ image: {
            ...fillInfo,
            src: ImageQuickLookManager.getInstance().getResourceByUrl(fillInfo.src)
                ?.getCdnUrl() || fillInfo.src,
            stretch: {
                fillRect: srcRect,
            },
        } });
    }
}
